const prefix = 'top-bar-search';

export const i18n = {
    placeholder: {
        id: `${prefix}.placeholder`,
        defaultMessage: 'Search instances, users, support packages…',
    },
    ariaLabel: {
        id: `${prefix}.ariaLabel`,
        defaultMessage: 'Global search',
    },
    clear: {
        id: `${prefix}.clear`,
        defaultMessage: 'Clear search',
    },
    groupInstances: {
        id: `${prefix}.groupInstances`,
        defaultMessage: 'Instances',
    },
    groupSubscriptions: {
        id: `${prefix}.groupSubscriptions`,
        defaultMessage: 'Subscriptions',
    },
    groupUsers: {
        id: `${prefix}.groupUsers`,
        defaultMessage: 'Users',
    },
    groupSupportPackages: {
        id: `${prefix}.groupSupportPackages`,
        defaultMessage: 'Support Packages',
    },
    groupWorkspaces: {
        id: `${prefix}.groupWorkspaces`,
        defaultMessage: 'Workspaces',
    },
    groupDatasets: {
        id: `${prefix}.groupDatasets`,
        defaultMessage: 'Datasets',
    },
    noResults: {
        id: `${prefix}.noResults`,
        defaultMessage: 'No matches found',
    },
    noResultsHint: {
        id: `${prefix}.noResultsHint`,
        defaultMessage: 'Try a different term or check spelling',
    },
    typePrompt: {
        id: `${prefix}.typePrompt`,
        defaultMessage: 'Type at least {min} characters to search…',
    },
    ownerBadge: {
        id: `${prefix}.ownerBadge`,
        defaultMessage: 'Owner',
    },
    noResultsInSection: {
        id: `${prefix}.noResultsInSection`,
        defaultMessage: 'No results',
    },
    moreMatches: {
        id: `${prefix}.moreMatches`,
        defaultMessage: 'More matches — refine your search',
    },
    filters: {
        id: `${prefix}.filters`,
        defaultMessage: 'Filters',
    },
    clearFilters: {
        id: `${prefix}.clearFilters`,
        defaultMessage: 'Clear filters',
    },
    closeFilters: {
        id: `${prefix}.closeFilters`,
        defaultMessage: 'Close filters',
    },
    filtersOnThisPage: {
        id: `${prefix}.filtersOnThisPage`,
        defaultMessage: 'Filters on this page',
    },
    allFilters: {
        id: `${prefix}.allFilters`,
        defaultMessage: 'All filters',
    },
    noPageFilters: {
        id: `${prefix}.noPageFilters`,
        defaultMessage: 'This page has no filterable columns.',
    },
    statusField: {
        id: `${prefix}.statusField`,
        defaultMessage: 'Status',
    },
    typeField: {
        id: `${prefix}.typeField`,
        defaultMessage: 'Type',
    },
    productCodeField: {
        id: `${prefix}.productCodeField`,
        defaultMessage: 'Product code',
    },
    productNameField: {
        id: `${prefix}.productNameField`,
        defaultMessage: 'Product name',
    },
    done: {
        id: `${prefix}.done`,
        defaultMessage: 'Done',
    },
} as const;
